import { Trans, useTranslation } from 'react-i18next';
import classes from './Benefits.module.scss';
import image from '../../../assets/img/ElectricalRepair/benefits.avif';

const Benefits = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <img className={classes.image} src={image} alt='' />
                <div className={classes.content}>
                    <h2 className={`${classes.title} font-48`}>
                        <Trans>
                            {t('electrical.benefits.title')}
                        </Trans>
                    </h2>
                    <p className={`${classes.text} font-16`}>
                        {t('electrical.benefits.text')}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Benefits;
